import React from "react"
import PropTypes from "prop-types"
import { Box, Typography, makeStyles } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: props => props.headingmb || "unset",
    "&.service-heading": {
      [theme.breakpoints.down("sm")]: {
        marginBottom: "30px",
      },
    },
  },
}))

const GeneralSection = props => {
  const { mb, heading, variant, children, ...rest } = props
  const classes = useStyles(props)

  return (
    <Box mb={mb} {...rest}>
      {heading && (
        <Typography className={classes.root} variant={variant} align="center">
          {heading}
        </Typography>
      )}
      {children}
    </Box>
  )
}

GeneralSection.propTypes = {
  mb: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  heading: PropTypes.string,
  headingmb: PropTypes.string,
  variant: PropTypes.string,
  children: PropTypes.node.isRequired,
}

export default GeneralSection
